import { IStudent } from "src/domain/entities"
import { studentListApi } from "../../api/student/studentListApi"

type PayloadShape = Parameters<typeof studentListApi>[0]

export async function studentListService(payload: PayloadShape, token?: null | string) {
	const student = await studentListApi(payload, token)
	return student as NonNullable<IStudent[]>
}
